import { useEffect, useState } from "react";
import gsap from "gsap";
import "../assets/Css/main.css";
import "../index.css"
import hover1 from "../assets/images/h1.png";
import hover2 from "../assets/images/h2.jpg";
import hover3 from "../assets/images/h3.jpg";
import hover4 from "../assets/images/g1.gif";
import hover5 from "../assets/images/g2.gif";
import hover6 from "../assets/images/g3.webp";
export default function Main() {
  const [cursorX, setCursorX] = useState(-50);
  const [cursorY, setCursorY] = useState(-50);

  useEffect(() => {
    const cursor = document.querySelector(".cursor");
    const cursorMedias = document.querySelectorAll(".cursor__media");
    const navLinks = document.querySelectorAll(".hover_image");

    gsap.set(cursor, {
      xPercent: -50,
      yPercent: -50,
      scale: 0,
    });

    const setCursorX = gsap.quickTo(cursor, "x", {
      duration: 0.6,
      ease: "expo",
    });

    const setCursorY = gsap.quickTo(cursor, "y", {
      duration: 0.6,
      ease: "expo",
    });

    const tl = gsap.timeline({
      paused: true,
    });

    tl.to(cursor, {
      scale: 1,
      opacity: 1,
      duration: 0.5,
      ease: "expo.inOut",
    });

    const handleMouseMove = (e) => {
      setCursorX(e.pageX);
      setCursorY(e.pageY);
    };

    const handleNavLinkMouseOver = (i) => {
      cursorMedias[i].classList.add("active");
      tl.play();
    };

    const handleNavLinkMouseOut = (i) => {
      tl.reverse();
      cursorMedias[i].classList.remove("active");
    };

    window.addEventListener("mousemove", handleMouseMove);

    navLinks.forEach((navLink, i) => {
      navLink.addEventListener("mouseover", () => handleNavLinkMouseOver(i));
      navLink.addEventListener("mouseout", () => handleNavLinkMouseOut(i));
    });

    return () => {
      // Cleanup: Remove event listeners when the component unmounts
      window.removeEventListener("mousemove", handleMouseMove);

      navLinks.forEach((navLink, i) => {
        navLink.removeEventListener("mouseover", () =>
          handleNavLinkMouseOver(i)
        );
        navLink.removeEventListener("mouseout", () => handleNavLinkMouseOut(i));
      });
    };
  }, [cursorX, cursorY]);
  return (
    <>
      <div className="main-wraaper">
        <div className="main-content">
          <div className="main-content-container">
            <div className="title-cont">
              <div
                className="cursor"
                style={{ left: `${cursorX}px`, top: `${cursorY}px` }}
              >
                <img src={hover4} className="cursor__media" />
                <img src={hover5} className="cursor__media" />
                <img src={hover6} className="cursor__media" />
              </div>
              <span className="title specific-pad">
                <h1 className="hover_image">We ARE  the best</h1>
              </span>
              <span className="title">
                <h1 className="hover_image">DIGITAL-SERVICE</h1>
              </span>
            </div>
            <div className="title-cont-para">
              <span className="title">
                <h1 className="hover_image">AGENCY</h1>
              </span>
              <div className="sidebar-text">003</div>
              <span className="main-content-paragraph">
                <p>
                  We Are  the Best <br /> creative agency Providing
                   <br /> technology to deliver best-in- <br />
                  class client experience.
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>

        
    </>
  );
}
